import React, { useEffect, useRef, useState } from 'react';
// import Editor from '../libs/editor';
import Editor from '../libs/QuillEditor';

import { useSelector, useDispatch } from 'react-redux';
import * as newsActions from '../../store/modules/newsSlice'
import { bindActionCreators } from 'redux';
import { htmlToDelta, deltaToHtml } from '../libs/QuillConverter';
import { showToast } from '../Common/Messages';

function buildFileSelector() {
    const fileSelector = document.createElement('input');
    fileSelector.setAttribute('type', 'file');
    fileSelector.setAttribute('multiple', 'multiple');
    return fileSelector;
}

const PostEditor = (props) => {
    const LoginStates = useSelector(state => state.login);
    const NewsStates = useSelector(state => state.news);
    const dispatch = useDispatch();
    const NewsActions = bindActionCreators(newsActions, dispatch);
    const editorRef = useRef(null);

    const [state, setState] = useState({
        writertitle: '',
        writercontent: '',
        files: [],
        formdata: new FormData()
    });
    const [category, setCategory] = useState('');
    const [fileSelector, setFileSelector] = useState(buildFileSelector());
    useEffect(() => {
        setCategory(props.current.category.split(',')[0]);
    }, [])
    useEffect(() => {
        if (fileSelector)
            fileSelector.addEventListener('change', addFileList);
    }, [fileSelector]);
    useEffect(() => {
        if(props.selectedPost) {
            setState(prev => { return {
                ...prev,
                writertitle: props.selectedPost.posttitle,
                writercontent: props.selectedPost.postcontent,
                files: props.selectedPost.attachfiles.map(x => {return {name: x.attachfilename, size: x.attachfilesize}}),
            }})
        }
    }, [props.selectedPost]);

    useEffect(() => {
        if (NewsStates.display == 'none') {
            if (state.writertitle != ''
                // || state.writercontent.trim() != '') {
                || editorRef.current?.getLength() > 1) {
                var r = window.confirm("작성중인 내용을 취소하겠습니까?");
                if (r) {
                    setState(prev => {
                        return {
                            ...prev,
                            writertitle: '',
                            writercontent: '',
                            files: []
                        }
                    });
                    editorRef.current?.setContents([]);
                    // editorRef.current?.setContents([{ insert: '\n' }]);
                    NewsActions.setDisplay({
                        display: 'none'
                    });
                } else {
                    NewsActions.setDisplay({
                        display: 'block'
                    });
                }
            }
            else {
                NewsActions.setDisplay({
                    display: 'none'
                });
            }
        }
    }, [NewsStates.display]);

    const handleChange = (e) => {
        if (e.hasOwnProperty('defaultPrevented'))
            e.preventDefault();
        const value = e.target.value == undefined ? e.target.innerHTML : e.target.value;
        setState(prev => {
            return {
                ...prev, [e.target.id]: value
            }
        }
        );

    };
    const addFileList = (e) => {
        let files = e.target.files;
        let list = state.files;
        var formdata = state.formdata;

        if (files.length == 0 || formdata == undefined) return;
        let start = list.length.toString();
        for (let i = 0; i < files.length; i++) {
            formdata.append('file_' + start++, files[i], files[i].name);

            list.push({ name: files[i].name, size: files[i].size });
        }
        setState(prev => {
            return {
                ...prev,
                files: list,
                formdata: formdata
            }
        });
    };

    const uploadFile = (e) => {
        e.preventDefault();
        fileSelector.click();
    };

    const removeFile = (e) => {
        e.preventDefault();
        var index = e.target.id;
        let filelist = state.files;
        var formdata = state.formdata;
        filelist.splice(index, 1);

        formdata.delete('file_' + index);
        setState(prev => {
            return {
                ...prev,
                files: filelist
            }
        });
        setFileSelector(buildFileSelector());
        // fileSelector.addEventListener('change', addFileList);
    };

    const fileList = () => {
        let list = [];
        let filesize = 0;

        for (let i = 0; i < state.files?.length; i++) {
            if (!isNaN(state.files[i].size)) {
                if (state.files[i].size < 1024) {
                    filesize = state.files[i].size.toFixed(1) + "byte";
                }
                else if (state.files[i].size < Math.pow(1024, 2)) {
                    filesize = (state.files[i].size / 1024).toFixed(1) + "kb";
                }
                else if (state.files[i].size < Math.pow(1024, 3)) {
                    filesize = (state.files[i].size / Math.pow(1024, 2)).toFixed(1) + "mb";
                }
                else {
                    filesize = (state.files[i].size / Math.pow(1024, 3)).toFixed(1) + "gb";
                }
                state.files[i].size = filesize;
            }
            list.push(
                <li>
                    <div class="file-list-each">
                        <i className='icoKdc24 download'></i>
                        <p className="filename" id="fileName">{state.files[i].name}</p>
                        <p className="filesize" id="fileSize">{state.files[i].size}</p>
                    </div>
                    <button className="btn-remove-file" id={i} onClick={e => removeFile(e)}><i id={i} className="icoKdc12 delete"></i></button>
                </li>
            );
        }
        return list;
    };

    const clickPost = (e) => {
        e.preventDefault();
        fetch('api/File/UploadFiles', {
            method: 'POST',
            body: state.formdata
        });

        if (NewsStates.display === 'block') {
            const content = deltaToHtml(editorRef.current.getContents());
            if (state.writertitle.trim() === ''
                // || state.writercontent.trim() == '') {
                || content.trim() === '') {
                showToast('danger', content, 3000);
            }
            else {
                const input = {
                    userId: LoginStates.userId,
                    userName: LoginStates.userName,
                    workingTag: 'postSave',
                    pageNo: 1,
                    groupNo: NewsStates.groupno,
                    postInfo: {
                        contentType: 'Post',
                        postSeq: props.selectedPost?.postSeq ?? 0,
                        attachSeq: 0,
                        commentSeq: 0,
                        postData: {
                            title: state.writertitle,
                            // content: state.writercontent,
                            content: content,
                            attachment: state.files,
                            comment: '',
                            category: category
                        }
                    }
                };
                props.executeFetch(input);
                setState(prev => {
                    return {
                        ...prev,
                        writertitle: '',
                        writercontent: '',
                        files: []
                    }
                });
                editorRef.current?.setContents([]);
                NewsActions.setDisplay({
                    display: 'none'
                });
                // child.current?.resetContent();
            }
        }
    };

    const clickWrite = (e) => {
        e.preventDefault();

        if (NewsStates.display == 'block') {
            if (state.writertitle != ''
                // || state.writercontent.trim() != ''
                || editorRef.current?.getLength() > 1
                || state.files.length > 0) {
                var r = window.confirm("작성중인 내용을 취소하겠습니까?");
                if (r) {
                    NewsActions.setDisplay({
                        display: 'none'
                    });
                    props.setSelectedPost(null);
                    setState(prev => {
                        return {
                            ...prev,
                            writertitle: '',
                            writercontent: '',
                            files: []
                        }
                    });
                    editorRef.current?.deleteText(0, editorRef.current?.getLength());
                } else {
                    return;
                }
            }
            else {
                NewsActions.setDisplay({
                    display: 'none'
                });
                props.setSelectedPost(null);
            }
        }
    };
    const selectCategory = (e) => {
        setCategory(e.target.value);
    }
    return (
        <section className="post-write" style={{ display: NewsStates.display }} >
            <ul className="write-box">
                <li className="post-title">
                    <select className='select-wrap' onChange={selectCategory}>
                        {props.current?.category?.split(',').map(x => { return <option value={x}>{x}</option> })}
                    </select>
                    <input
                        className='title-wrap'
                        type="text"
                        placeholder="제목을 입력하세요"
                        id="writertitle"
                        value={state.writertitle}
                        onChange={(e) => handleChange(e)} />

                </li>
                <li className="post-content">
                    <Editor
                        ref={editorRef}
                        readOnly={false}
                        defaultValue={htmlToDelta(props.selectedPost?.postcontent ?? "")}
                    />
                    <div className="post-files">
                        <div className="title">첨부파일<button className="btn-add-file" onClick={uploadFile}><i className="icoKdc20 add-g"></i></button></div>
                        <ul className="attached-files">
                            {fileList()}
                        </ul>
                    </div>
                </li>
               
            </ul>
            <div className="btn-wrap">
                <button className="btn-secondary" onClick={clickWrite}>취소</button>
                <button className="btn-primary" onClick={clickPost}>{props.selectedPost ? "수정" : "등록"}</button>
            </div>
        </section>
    );
};
export default PostEditor;